module.exports = __webpack_public_path__ + "static/media/language71562767.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/language.svg
// module id = 1332
// module chunks = 0